import React, { useState, useEffect } from 'react';
import './index.css';

const GREETINGS = [
  'Hola',       // Spanish
  'Bonjour',    // French
  'Hallo',      // German
  'Ciao',       // Italian
  'こんにちは',  // Japanese
  '你好',        // Chinese
  '안녕하세요',  // Korean
  'Привет',     // Russian
  'नमस्ते',    // Hindi
  'Merhaba',    // Turkish
  'Olá',        // Portuguese
  'Sawubona',   // Zulu
  'مرحبا',      // Arabic
  'Chào',       // Vietnamese
  'Γειά σας',  // Greek
  'Shalom',     // Hebrew
  'Hei',        // Finnish
  'Halo',       // Indonesian
  'Hello',      // English
];

const Preloader = ({ onComplete }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => {
        if (prev < GREETINGS.length - 1) {
          return prev + 1;
        }
        clearInterval(interval);
        setTimeout(onComplete, 1000);
        return prev;
      });
    }, 110);
    return () => clearInterval(interval);
  }, [onComplete]);

  return (
    <div className="preloader">
      {/* Animated grid background */}
      <svg
        className="absolute inset-0 w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
        style={{ opacity: 0.04 }}
      >
        <defs>
          <pattern id="pre-grid" width="50" height="50" patternUnits="userSpaceOnUse">
            <path d="M 50 0 L 0 0 0 50" fill="none" stroke="#00f5ff" strokeWidth="0.5" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#pre-grid)" />
      </svg>

      {/* Corner arcs */}
      <svg
        className="absolute top-0 right-0"
        width="200" height="200" viewBox="0 0 200 200"
        style={{ opacity: 0.12 }}
      >
        <circle cx="200" cy="0" r="100" fill="none" stroke="#00f5ff" strokeWidth="1" />
        <circle cx="200" cy="0" r="60"  fill="none" stroke="#ff00de" strokeWidth="0.6" />
      </svg>
      <svg
        className="absolute bottom-0 left-0"
        width="200" height="200" viewBox="0 0 200 200"
        style={{ opacity: 0.12 }}
      >
        <circle cx="0" cy="200" r="100" fill="none" stroke="#ff00de" strokeWidth="1" />
        <circle cx="0" cy="200" r="60"  fill="none" stroke="#7c3aed" strokeWidth="0.6" />
      </svg>

      {/* Greeting text */}
      <div className="translation">{GREETINGS[currentIndex]}</div>

      {/* Orbiting ring decoration */}
      <div
        className="absolute"
        style={{
          width: 180,
          height: 180,
          border: '1px solid rgba(0,245,255,0.15)',
          borderRadius: '50%',
          animation: 'spin-slow 6s linear infinite',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: -4, left: '50%',
            transform: 'translateX(-50%)',
            width: 8, height: 8,
            borderRadius: '50%',
            background: '#00f5ff',
            boxShadow: '0 0 8px #00f5ff, 0 0 16px #00f5ff',
          }}
        />
      </div>
      <div
        className="absolute"
        style={{
          width: 220,
          height: 220,
          border: '1px solid rgba(255,0,222,0.1)',
          borderRadius: '50%',
          animation: 'spin-reverse 9s linear infinite',
        }}
      />

      {/* Progress dots */}
      <div className="absolute bottom-12 flex gap-1.5">
        {GREETINGS.map((_, i) => (
          <div
            key={i}
            style={{
              width: i === currentIndex ? 16 : 6,
              height: 4,
              borderRadius: 2,
              background: i <= currentIndex ? '#00f5ff' : 'rgba(0,245,255,0.15)',
              boxShadow: i === currentIndex ? '0 0 6px #00f5ff' : 'none',
              transition: 'all 0.2s ease',
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default Preloader;
